import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';
import Link from 'components/link';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockAcquireReliabilityReports');

@I18nHoc(translates())
export default class AcquireReliabilityReportsBlock extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className } = this.props;
    const urlArticle = 'https://domik.ua/novosti/rabotu-portala-bildua-otmetil-vice-premer-mixail-fedorov-n260510.html';
    const textArticle = 'Нашу работу отметил вице-премьер-министр по цифровой трансформации Михаил Федоров';
    const textArticleUa = 'Нашу роботу відзначив віце-прем\'єр-міністр з цифрової трансформації Михайло Федоров';

    return (
      <div {...classes({ extra: className })}>
        <Trans lang="ru">
          <Row {...classes('row', 'block')}>
            <Col {...classes('col', 'info')} allPr={0}>
              <Row {...classes('row', 'info')} mtColumn mpColumn>
                <Col {...classes('col', 'h2')} allPr={0}>
                  <div {...classes('text', 'h2')}><h2 children="Детальный отчёт о надёжности новостройки ─ ваш надёжный помощник" /></div>
                </Col>
                <Col {...classes('col', 'description')} allPr={0}>
                  <ul {...classes('list', 'main')}>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text', 'description')} children="Он позволяет взглянуть на проект ЖК, располагая всей доступной информацией для принятия взвешенного решения об инвестировании." />
                      </div>
                    </li>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text', 'topic')}>
                          <Link
                            {...classes('link', 'inline')}
                            href={urlArticle}
                            title={textArticle}
                            noRedirector
                            external
                            blank
                          >
                            <span {...classes('linkContent')}>
                              <span
                                {...classes('text')}
                                children={textArticle}
                              />
                            </span>
                          </Link>
                        </p>
                      </div>
                    </li>
                  </ul>
                </Col>
              </Row>
              <ul {...classes('list', 'cols')}>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text', 'description')} children="Каждый отчёт актуализируется нами на момент заказа. Сразу после оплаты вы получаете на электронную почту существующий отчёт, а наши эксперты получают заказ на актуализацию. В течение трех рабочих дней мы проверяем все данные отчёта, берём новое извлечение из реестра вещных прав, проверяем реестры, дополняем отчёт новыми данными и присылаем вам уже актуализированный отчёт повторно." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text', 'description')} children="Если не прошло 30-ти дней с момента последней актуализации данных отчёта, то такой отчёт вы можете заказать без услуги актуализации данных. По сути, это свежий отчёт. Вам ─ экономия денег, нам ─ экономия ручного труда. Помимо отчёта и актуализации данных, вы можете получить консультацию нашего эксперта по телефону или любым удобным вам способом." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text', 'description')} children="Мы разъясним вам содержание отчёта еще более человеческим языком и ответим на все ваши вопросы. Иногда люди находили наш сервис в последний момент и просили сделать отчёт в сжатые сроки. Теперь вам доступна такая опция в наборе услуг. При необходимости, мы можем выполнить некоторые ваши заказы за 24 часа." />
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Trans>
        <Trans lang="ua">
          <Row {...classes('row', 'block')}>
            <Col {...classes('col', 'info')} allPr={0}>
              <Row {...classes('row', 'info')} mtColumn mpColumn>
                <Col {...classes('col', 'h2')} allPr={0}>
                  <div {...classes('text', 'h2')}><h2 children="Детальний звіт про надійність новобудови ─ ваш надійний помічник" /></div>
                </Col>
                <Col {...classes('col', 'description')} allPr={0}>
                  <ul {...classes('list', 'main')}>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text', 'description')} children="Він дозволяє поглянути на проєкт ЖК, маючи в своєму розпорядженні всю доступну інформацію для прийняття зваженого рішення про інвестування." />
                      </div>
                    </li>
                    <li {...classes('listItem')}>
                      <div {...classes('description')}>
                        <p {...classes('text', 'topic')}>
                          <Link
                            {...classes('link', 'inline')}
                            href={urlArticle}
                            title={textArticleUa}
                            noRedirector
                            external
                            blank
                          >
                            <span {...classes('linkContent')}>
                              <span
                                {...classes('text')}
                                children={textArticleUa}
                              />
                            </span>
                          </Link>
                        </p>
                      </div>
                    </li>
                  </ul>
                </Col>
              </Row>
              <ul {...classes('list', 'cols')}>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text', 'description')} children="Кожен звіт актуалізується нами на момент замовлення. Відразу після оплати ви отримуєте на електронну пошту існуючий звіт, а наші експерти отримують замовлення на актуалізацію. Протягом трьох робочих днів ми перевіряємо всі дані звіту, беремо новий витяг з реєстру речових прав, перевіряємо реєстри, доповнюємо звіт новими даними і надсилаємо вам вже актуалізований звіт вдруге." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text', 'description')} children="Якщо не пройшло 30-ти днів із моменту останньої актуалізації даних звіту, то такий звіт ви можете замовити без послуги актуалізації даних. По суті, це свіжий звіт. Вам ─ економія грошей, нам ─ економія ручної праці. Крім звіту і актуалізації даних, ви можете отримати консультацію нашого експерта за телефоном або у будь-який зручний для вас спосіб." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text', 'description')} children="Ми пояснимо вам зміст звіту ще більш доступною мовою і відповімо на всі ваші запитання. Іноді люди знаходили наш сервіс в останній момент і просили зробити звіт у стислі терміни. Тепер вам доступна така опція в переліку послуг. За необхідності, ми можемо виконати деякі ваші замовлення за 24 години." />
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
        </Trans>
      </div>
    );
  }
}
